<template>
	  <div class="map">
		<l-map :zoom="zoom" :center="center">
		  <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
		  <l-marker
            v-for="marker in markers"
            :key="marker.id"
            :visible="marker.visible"
            :lat-lng="marker.position">
			<l-popup :content="marker.description" />
		  </l-marker>
		</l-map>
	  </div>
</template>

<script>
import {LMap, LTileLayer, LMarker, LPopup} from 'vue2-leaflet';
import L from 'leaflet';
import axios from 'axios';

export default {
  data() {
    return {
	  dataReceived: '',
      zoom: 16,
	  //Clube de Campo	
      //center: L.latLng(37.8891, -8.0205),
	  //Ericeira	
      center: L.latLng(38.9601827, -9.4175394),
      url:'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
      attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      markers: [],
    }
  },
  components: {
	LMap,
	LMarker,
	LTileLayer,
	LPopup,  
  }, 
  methods: {
	fetchData: async function () {
		//let json = await axios.get('json/ClubeCampo.json');
		let json = await axios.get('json/Ericeira.json');
		return json;
	},
	showPoints: async function() {
	
	  //Gets the data from the json file 
	  this.poi = await this.fetchData();
		
	  //Change the context so that we can push the markers	
	  const that = this;

	  //Iterate through this.poi to display multiple markers
	  this.poi.data.forEach(function(node) {
			
		    var description;
			var tags = node.tag;
			
			if (tags['@attributes']) {
				
				description = '<b>' + tags['@attributes'].k + '</b>: ' + tags['@attributes'].v;
			
			} else {

				description = '';

				//Build description from multiple attribute nodes
				tags.forEach(function(tag) {
				
					if(tag['@attributes']){
						description += '<b>' + tag['@attributes'].k + '</b>: ' + tag['@attributes'].v + '<br />';
					}
				});
			}
			
		    var newMarker = {
			    position: { lat: node['@attributes'].lat, lng: node['@attributes'].lon },
			    visible: true,
			    description: description  
	        };
		  // Add marker to the map
		  that.markers.push(newMarker);
		});
	}
  },
  mounted() {
	  this.showPoints();
  },
};
</script>

<style>
    .map {
	    height: 800px;
		margin: 0;
	}
</style>
